document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.testimonials-section').forEach(function(slideContainer, index) {
        const swiperContainer = slideContainer.querySelector('.swiper');
        const scrollbar = slideContainer.querySelector('.swiper-scrollbar');
        const nextButton = slideContainer.querySelector('.next');
        const prevButton = slideContainer.querySelector('.prev');

        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            grabCursor: true,
            autoHeight: true,
            scrollbar: {
                el: scrollbar,
                hide: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                }
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
        });
    });


    document.querySelectorAll('.product-slider-section').forEach(function(slideContainer, index) {
        const swiperContainer = slideContainer.querySelector('.swiper');
        const scrollbar = slideContainer.querySelector('.swiper-scrollbar');
        const nextButton = slideContainer.querySelector('.next');
        const prevButton = slideContainer.querySelector('.prev');

        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 30,
            grabCursor: true,
            scrollbar: {
                el: scrollbar,
                hide: false,
            },
            breakpoints: {
                500: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 4,
                },
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
        });
    });

    /*const footer = document.querySelector(".footer-utilities__text");
    if (footer) {
        footer.innerHTML = `
      <span>PIMABÉ 2026, MÜNCHEN ❤️<br>WEBSITE <a style="text-decoration: underline" href="https://www.youknowmewell.net" target="_blank" rel="noopener">YOU KNOW ME WELL STUDIO</a></span>
    `;
    }


    document.querySelectorAll('.product-card').forEach(card => {
        const quickAdd = card.querySelector('quick-add-component');
        const groupContent = card.querySelector('.group-block-content');

        if (quickAdd && groupContent) {
            groupContent.appendChild(quickAdd);
        }
    });*/
});
